:root {
    --color-primary: #54535C;
    --color-primary-light: rgba(84, 83, 92, 0.2);
    --color-primary-medium: #54535c91;
    --color-border: #e0e0e0;
    --border-radius: 8px;
    --spacing-sm: 8px;
    --spacing-md: 15px;
    --spacing-lg: 20px;
    --spacing-xl: 25px;
    --font-size-xs: 11px;
    --font-size-sm: 12px;
    --font-size-md: 14px;
    --font-size-lg: 16px;
    --connector-size-large: 100px;
    --connector-size-medium: 60px;
    --connector-size-small: 30px;
    --connector-size-xsmall: 20px;
    --circle-size-large: 60px;
    --circle-size-medium: 50px;
    --circle-size-small: 40px;
    --circle-size-xsmall: 35px;
}

.installments.payment-progress {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    max-width: 800px;
    padding: var(--spacing-lg);
}

.installments.payment-progress.bordered {
    border: 1px solid var(--color-border);
    border-radius: var(--border-radius);
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
    padding: var(--spacing-xl);
}

/* Step styles */
.installments-step {
    display: flex;
    flex-direction: column;
    align-items: center;
    position: relative;
    flex: 0 0 auto;
}

.installments-amount {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
}

.amount-container {
    display: flex;
    align-items: center;
    gap: 2px;
}

.installments-label {
    font-size: var(--font-size-md);
    color: var(--color-primary);
    font-weight: 400;
    text-align: center;
}

.installments-amount-value {
    font-weight: bold;
}

.currency-symbol {
    margin-right: 2px;
}

.sar-symbol {
    width: 16px;
    height: 16px;
    display: inline-block;
    fill: var(--color-primary);
    margin-right: 3px;
    vertical-align: middle;
}

.installments-circle-container {
    position: relative;
    width: var(--circle-size-large);
    height: var(--circle-size-large);
    margin-bottom: var(--spacing-md);
}

.installments-circle-outline,
.installments-circle-filled,
.installments-circle-filled-first,
.installments-circle-segment {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    border-radius: 50%;
}

.installments-circle-outline {
    background-color: var(--color-primary-light);
}

.installments-circle-filled-first {
    background-color: var(--color-primary-medium);
}

.installments-circle-filled {
    background-color: var(--color-primary);
}

.installments-circle-segment-small {
    clip-path: polygon(50% 50%, 50% 0%, 25% 0%, 15% 15%, 50% 50%);
    background-color: var(--color-primary);
}

.installments-circle-segment-medium {
    clip-path: polygon(50% 50%, 50% 0%, 0% 0%, 0% 50%, 50% 50%);
    background-color: var(--color-primary);
}

.installments-connector-container {
    flex-grow: 1;
    display: flex;
    align-items: center;
    position: relative;
    margin: 0 var(--spacing-sm);
    max-width: var(--connector-size-large);
}

.installments-simple-connector,
.installments-dotted-connector {
    display: flex;
    align-items: center;
    width: 100%;
}

.installments-connector-dot {
    width: 8px;
    height: 8px;
    background-color: var(--color-primary);
    border-radius: 50%;
}

.installments-connector-line {
    flex-grow: 1;
    height: 2px;
    background-color: var(--color-primary);
    margin: 0 2px;
}

.installments-dots-container {
    flex-grow: 1;
    display: flex;
    justify-content: space-evenly;
    align-items: center;
}

.installments-dot {
    width: 6px;
    height: 6px;
    background-color: var(--color-primary);
    border-radius: 50%;
    margin: 0 2px;
}

@container (max-width: 600px) {
    .installments-circle-container {
        width: var(--circle-size-medium);
        height: var(--circle-size-medium);
    }

    .installments-connector-container {
        max-width: var(--connector-size-medium);
    }

    .installments-label {
        font-size: var(--font-size-md);
    }
}

@container (max-width: 450px) {
    .installments.payment-progress {
        flex-direction: row;
        flex-wrap: nowrap;
        overflow-x: auto;
        justify-content: flex-start;
        gap: var(--spacing-md);
    }

    .installments-circle-container {
        width: var(--circle-size-small);
        height: var(--circle-size-small);
        margin-bottom: var(--spacing-sm);
    }

    .installments-connector-container {
        max-width: var(--connector-size-small);
    }

    .installments-label {
        font-size: var(--font-size-sm);
    }
}

@media (max-width: 768px) {
    .installments.payment-progress {
        padding: var(--spacing-md) 0;
    }

    .installments.payment-progress.bordered {
        padding: var(--spacing-lg) var(--spacing-md);
    }

    .installments-circle-container {
        width: var(--circle-size-medium);
        height: var(--circle-size-medium);
    }

    .installments-amount {
        font-size: var(--font-size-lg);
        margin-bottom: var(--spacing-sm);
    }

    .installments-label {
        font-size: var(--font-size-md);
    }

    .installments-connector-container {
        margin: 0 5px;
        max-width: var(--connector-size-medium);
    }
}

@media (max-width: 576px) {
    .installments.payment-progress {
        flex-direction: row;
        flex-wrap: nowrap;
        overflow-x: auto;
        justify-content: flex-start;
        padding: var(--spacing-md) 0;
        gap: 17px;
    }

    .installments.payment-progress.bordered {
        padding: var(--spacing-md) var(--spacing-sm);
    }

    .installments-step {
        flex-direction: column;
        align-items: center;
        width: auto;
        flex: 0 0 auto;
        margin-bottom: 0;
        padding: 0;
    }

    .installments-amount {
        font-size: var(--font-size-md);
        margin-bottom: var(--spacing-sm);
        text-align: center;
    }

    .installments-circle-container {
        width: var(--circle-size-small);
        height: var(--circle-size-small);
        margin-bottom: var(--spacing-sm);
    }

    .installments-label {
        font-size: var(--font-size-sm);
    }

    .installments-connector-container {
        width: auto;
        flex: 0 0 var(--connector-size-small);
        margin: 0 2px;
    }

    .installments-connector-dot {
        width: 6px;
        height: 6px;
    }

    .installments-dot {
        width: 4px;
        height: 4px;
    }
}

@media (max-width: 400px) {
    .installments-amount {
        font-size: var(--font-size-sm);
        margin-bottom: 6px;
    }

    .installments-circle-container {
        width: var(--circle-size-xsmall);
        height: var(--circle-size-xsmall);
        margin-bottom: 6px;
    }

    .installments-label {
        font-size: var(--font-size-xs);
    }

    .installments-connector-container {
        flex: 0 0 var(--connector-size-xsmall);
    }

    .installments.payment-progress.bordered {
        padding: var(--spacing-sm) var(--spacing-sm);
    }
}

@supports (container-type: inline-size) {
    .installments.payment-progress {
        container-type: inline-size;
        container-name: payment-progress;
    }
}